import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'admissions',
    lazy: async () => ({ Component: (await import('./AdmissionsPage')).AdmissionsPage }),
  },
];
